/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDocument } from '../../models/user-document';

export interface UserDocumentsControllerUploadDocument$Params {
  userId: string;
      body: {
'file'?: Blob;
}
}

export function userDocumentsControllerUploadDocument(http: HttpClient, rootUrl: string, params: UserDocumentsControllerUploadDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDocument>> {
  const rb = new RequestBuilder(rootUrl, userDocumentsControllerUploadDocument.PATH, 'post');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDocument>;
    })
  );
}

userDocumentsControllerUploadDocument.PATH = '/user-documents/{userId}';
